<template>
  <div>
    <section class="grid-flex">
      <div class="box">
        <div class="box-title flex between middle">
          <h2 class="">
            Conta
          </h2>
        </div>
        <div class="box-content">
          <div class="flex">
            <!-- form account info -->
            <div class="flex-1 account">
              <h4>Dados de cadastro</h4>
              <div class="flex column margin-top-m">
                <div class="flex-1 w100">
                  <label>ID</label>
                  <input
                    class="input"
                    type="text"
                    v-model="account.id"
                    disabled=""
                    readonly=""
                  />
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>Nome</label>
                  <input class="input" type="text" v-model="account.name" />
                </div>

                <!-- CRM Auto-add Contact Configuration (Premium Design Card) -->
                <div class="crm-integration-card margin-top-l">
                  <div class="crm-card-header flex middle between">
                    <div class="flex middle gap-s">
                      <div class="crm-card-icon">
                        <i class="fas fa-project-diagram"></i>
                      </div>
                      <div>
                        <h4 class="crm-card-title">Automação de Funil (CRM)</h4>
                        <p class="crm-card-subtitle">Direcione contatos novos para o seu funil de vendas automaticamente.</p>
                      </div>
                    </div>
                    <!-- iOS Toggle Switch -->
                    <label class="switch-toggle">
                      <input 
                        type="checkbox" 
                        v-model="account.auto_add_contact_pipeline"
                      />
                      <span class="switch-slider"></span>
                    </label>
                  </div>

                  <div v-if="account.auto_add_contact_pipeline" class="crm-card-body animate-fade-in">
                    <div class="grid-layout margin-top-m">
                      <div class="form-group">
                        <label class="form-label">
                          <i class="fas fa-filter text-muted margin-right-xs"></i> Funil de Vendas de Destino
                        </label>
                        <div class="select-container">
                          <select 
                            v-model="selectedPipeline" 
                            @change="onPipelineChange" 
                            class="custom-select"
                          >
                            <option :value="null">Selecione o funil desejado...</option>
                            <option v-for="p in pipelines" :key="p.id" :value="p">
                              {{ p.name }}
                            </option>
                          </select>
                          <i class="fas fa-chevron-down select-arrow"></i>
                        </div>
                      </div>

                      <div v-if="selectedPipeline" class="form-group">
                        <label class="form-label">
                          <i class="fas fa-map-marker-alt text-muted margin-right-xs"></i> Etapa do Funil de Destino
                        </label>
                        <div class="select-container">
                          <select 
                            v-model="selectedStep" 
                            @change="onStepChange" 
                            class="custom-select"
                          >
                            <option :value="null">Selecione a etapa de entrada...</option>
                            <option v-for="s in selectedPipeline.steps" :key="s.id" :value="s">
                              {{ s.name }}
                            </option>
                          </select>
                          <i class="fas fa-chevron-down select-arrow"></i>
                        </div>
                      </div>

                      <div v-if="selectedPipeline" class="form-group animate-fade-in">
                        <label class="form-label">
                          <i class="fas fa-dollar-sign text-muted margin-right-xs"></i> Valor Comercial Padrão do Negócio
                        </label>
                        <div class="select-container" style="position: relative;">
                          <input 
                            v-model.number="account.auto_add_contact_deal_value" 
                            type="number" 
                            step="0.01" 
                            min="0" 
                            placeholder="0,00" 
                            class="custom-select" 
                            style="padding-left: 36px; padding-right: 12px; cursor: text;"
                          />
                          <span style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); font-weight: 700; color: #a0aec0; font-size: 1rem;">R$</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="flex center margin-top-l">
                <div class="button primary" @click="updateAccount()">
                  SALVAR
                </div>
              </div>
            </div>
            <!-- subscription info -->
            <div class="flex-1 subscription">
              <h4>Assinatura</h4>
              <div v-if="!isFreemium" class="margin-top-l">

                <div v-if="isAccountLimitExceeded" class="margin-top-l">
                  <h3 style="color:red">Atenção: Você passou do limite de pedidos pagos no mês para seu plano.</h3>
                  <br>
                  <p>Para continuar usando o sistema é necessário fazer o upgrade de plano clicando no botão abaixo:</p>
                </div>

                <!-- stripe panel -->
                <div v-if="isStripe">
                  <button @click="generateSessionStripe()" class="button primary">
                    {{  isAccountLimitExceeded ? 'Fazer Upgrade de Plano' : 'Gerenciar Assinatura' }}
                  </button>
                </div>
                <div v-else>
                  <a href="https://kiwify.com.br" target="_blank">
                    <button class="button primary">
                      Gerenciar Assinatura (KIWIFY)
                    </button>
                  </a>
                </div>
                <div class="margin-top-l">
                  <p>
                    Clique no botão gerenciar assinatura para conseguir realizar as tarefas abaixo:
                  </p>
                  <ul>
                    <li>Alteração de Cartão.</li>
                    <li>Alteração de Plano.</li>
                    <li>Cancelamento</li>
                  </ul>
                  <p>Caso ainda tenha dúvidas. Enviar e-mail para:</p>
                  <p class="margin-top-s">contato@lucreihoje.com.br</p>
                </div>
              </div>
              <div v-else>
                <div class="margin-top-l">
                  <h2>Você está no plano gratuito.</h2>
                  <p>Faça uma assinatura para ter acesso a todos os recursos da plataforma!</p>
                </div>
                <div class="margin-top-l">
                  <h3 style="color:red">Atenção: Você passou do limite de pedidos pagos no mês para seu plano.</h3>
                  <br>
                  <p>Para continuar usando o sistema é necessário fazer o upgrade de plano clicando no botão abaixo:</p>
                </div>
                <div class="margin-top-l">
                  <a :href="`https://lucreihoje.com.br/escolha-seu-plano.html?freemium=true&email=${account && account.email}&phone=${account && account.phone}`" target="_blank">
                    <button class="button primary">
                      {{  isAccountLimitExceeded ? 'Fazer Upgrade de Plano (ASSINAR)' : 'ASSINAR' }}
                    </button>
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { updateAccount } from "@/services/account";
import { getPipelines } from "@/services/pipeline";

import {
  createSessionStripe,
} from "@/services/subscription";


export default {
  name: "config-account",
  components: {},
  data() {
    return {
      loading: false,
      listCurrency: [
        {
          value: 'BRL',
          label: 'Real Brasileiro (BRL)'
        },
        {
          value: 'USD',
          label: 'Dólar Americano (USD)'
        }
      ],
      pipelines: [],
      selectedPipeline: null,
      selectedStep: null,
    };
  },
  mounted() {
    this.fetchPipelines();
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isStripe() {
      return this.account && this.account.payment_platform === 'STRIPE'
    },
    isFreemium() {
      return this.account && this.account.plan === 'freemium'
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === 'LIMIT_EXCEEDED'
    },
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    generateSessionStripe() {
      createSessionStripe()
        .then(result => {
          window.location.href = result.recirect_url;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao criar sessão na STRIPE"
          });
        });
    },
    fetchPipelines() {
      getPipelines()
        .then((response) => {
          this.pipelines = response.pipelines || [];
          this.syncSelectedPipelineAndStep();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    syncSelectedPipelineAndStep() {
      if (this.account && this.account.auto_add_contact_pipeline_id) {
        const pipe = this.pipelines.find(p => p.id === this.account.auto_add_contact_pipeline_id);
        if (pipe) {
          this.selectedPipeline = pipe;
          if (this.account.auto_add_contact_step_id) {
            const step = pipe.steps.find(s => s.id === this.account.auto_add_contact_step_id);
            if (step) {
              this.selectedStep = step;
            }
          }
        }
      }
    },
    onPipelineChange() {
      this.selectedStep = null;
      if (this.selectedPipeline) {
        this.account.auto_add_contact_pipeline_id = this.selectedPipeline.id;
        this.account.auto_add_contact_step_id = null;
      } else {
        this.account.auto_add_contact_pipeline_id = null;
        this.account.auto_add_contact_step_id = null;
      }
    },
    onStepChange() {
      if (this.selectedStep) {
        this.account.auto_add_contact_step_id = this.selectedStep.id;
      } else {
        this.account.auto_add_contact_step_id = null;
      }
    },
    updateAccount() {
      let params = {
        name: this.account.name,
        tax_rate: this.account.tax_rate,
        currency_preference: this.account.currency_preference,
        auto_add_contact_pipeline: this.account.auto_add_contact_pipeline,
        auto_add_contact_pipeline_id: this.account.auto_add_contact_pipeline_id,
        auto_add_contact_step_id: this.account.auto_add_contact_step_id,
        auto_add_contact_deal_value: this.account.auto_add_contact_deal_value,
      };
      updateAccount(params)
        .then((result) => {
          this.$store.dispatch("setAccount", result);
          this.syncSelectedPipelineAndStep();
          this.$toast.success({
            title: "Sucesso",
            message: "Conta atualizada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.account {
  padding: 16px;
  border-right: 1px solid #c2c2c235;
}

.subscription {
  padding: 16px;
  ul {
    padding-left: 15px;
    li {
      // list-style-type: none;
      padding-top: 8px;
      padding-bottom: 8px;
      margin-bottom: 8px;
    }
  }
}

// Premium CRM Integration Card Design
.crm-integration-card {
  background: var(--color-white, #ffffff);
  border: 1px solid var(--color-grey-2, #dee0e3);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    border-color: rgba(125, 7, 7, 0.3);
    box-shadow: 0 6px 18px rgba(125, 7, 7, 0.05);
  }
}

.crm-card-header {
  gap: 16px;
}

.crm-card-icon {
  width: 46px;
  height: 46px;
  background: rgba(125, 7, 7, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7d0707;
  font-size: 1.35rem;
  flex-shrink: 0;
}

.crm-card-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-brand-black, #111111);
}

.crm-card-subtitle {
  margin: 4px 0 0 0;
  font-size: 0.95rem;
  color: var(--color-grey-3, #777777);
  line-height: 1.4;
}

// iOS Toggle Switch Style
.switch-toggle {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 26px;
  flex-shrink: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .switch-slider {
      background-color: #7d0707;
    }

    &:checked + .switch-slider:before {
      transform: translateX(22px);
    }
  }

  .switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #dee0e3;
    transition: .3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 34px;

    &:before {
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: .3s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 50%;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    }
  }
}

// Card Inner Form Layout
.crm-card-body {
  border-top: 1px dashed var(--color-grey-2, #dee0e3);
  margin-top: 16px;
  padding-top: 8px;
}

.grid-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-brand-black, #111111);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.text-muted {
  color: var(--color-grey-3, #888888);
}

.margin-right-xs {
  margin-right: 6px;
}

// Premium Custom Select dropdown styling
.select-container {
  position: relative;
  display: flex;
  align-items: center;

  .select-arrow {
    position: absolute;
    right: 12px;
    color: var(--color-grey-3, #777777);
    font-size: 0.95rem;
    pointer-events: none;
    transition: transform 0.2s ease;
  }

  &:hover .select-arrow {
    color: #7d0707;
  }
}

.custom-select {
  width: 100%;
  padding: 11px 36px 11px 12px;
  font-size: 1rem;
  border: 1px solid var(--color-grey-2, #dee0e3);
  border-radius: 8px;
  background: var(--color-white, #ffffff);
  color: var(--color-brand-black, #111111);
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    border-color: #7d0707;
    outline: none;
    box-shadow: 0 0 0 3px rgba(125, 7, 7, 0.1);
  }

  &:hover {
    border-color: var(--color-grey-3, #888888);
  }
}

// Animations
.animate-fade-in {
  animation: fadeInCard 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes fadeInCard {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
